import React, { useMemo, useState } from 'react'

import * as S from './styles'

import { Typography } from '../../../components/Typography/styles'
import DashIcon from '../../../assets/Icons/DashIcon'
import CardIcon from '../../../assets/Icons/CardIcon'

import history from '../../../store/history'
import UsersIcon from '../../../assets/Icons/UsersIcon'
import LocalStorageService from '../../../services/LocalStorageService'
import { Roles, UserRoles } from '../../../constants/roles'

const UserSideBar = ({ path }) => {
  const [selected, setSelected] = useState(path)
  const user = LocalStorageService.get('user')

  const userRole = useMemo(() => {
    return user?.role
  }, [user])

  const handleClick = (value) => {
    const pathNames = {
      dashboard: { name: 'dashboard', path: '/user/dashboard' },
      brands: { name: 'brands', path: '/user/brands' },
      payments: { name: 'payments', path: '/user/payments' },
      users: { name: 'users', path: '/user/users' }
    }

    setSelected(pathNames[value].name)
    history.push(pathNames[value].path)
  }

  if (!UserRoles.includes(userRole)) {
    return null
  }

  return (
    <S.SideBarContainer>
      {/* {userRole !== Roles.PILLAR_OWNER && (
        <S.ButtonContainer onClick={() => handleClick('dashboard')}>
          <S.IconContainer selected={selected === 'dashboard'}>
            <HomeIcon
              color={selected === 'dashboard' ? '#BE9137' : '#DFE6F1'}
            />
            <Typography
              type="label"
              spacing="4px 0 0 0"
              weight={selected === 'dashboard' ? 800 : 'normal'}
            >
              {' '}
              DashBoard
            </Typography>
          </S.IconContainer>
        </S.ButtonContainer>
      )} */}
      <S.ButtonContainer onClick={() => handleClick('brands')}>
        <S.IconContainer selected={selected === 'brands'}>
          <DashIcon color={selected === 'brands' ? '#BE9137' : '#DFE6F1'} />
          <Typography
            type="label"
            spacing="4px 0 0 0"
            weight={selected === 'brands' ? 800 : 'normal'}
          >
            {' '}
            Lojas
          </Typography>
        </S.IconContainer>
      </S.ButtonContainer>
      {userRole !== Roles.PILLAR_OWNER && (
        <>
          <S.ButtonContainer onClick={() => handleClick('payments')}>
            <S.IconContainer selected={selected === 'payments'}>
              <CardIcon
                color={selected === 'payments' ? '#BE9137' : '#DFE6F1'}
              />
              <Typography
                type="label"
                spacing="4px 0 0 0"
                weight={selected === 'payments' ? 800 : 'normal'}
              >
                {' '}
                Pagamentos
              </Typography>
            </S.IconContainer>
          </S.ButtonContainer>
          <S.ButtonContainer onClick={() => handleClick('users')}>
            <S.IconContainer selected={selected === 'users'}>
              <UsersIcon color={selected === 'users' ? '#BE9137' : '#DFE6F1'} />
              <Typography
                type="label"
                spacing="4px 0 0 0"
                weight={selected === 'users' ? 800 : 'normal'}
              >
                {' '}
                Usuários
              </Typography>
            </S.IconContainer>
          </S.ButtonContainer>
        </>
      )}
    </S.SideBarContainer>
  )
}

export default UserSideBar
